import { GOVERNANCE_PORTAL_ROOT, PROVIDER_PORTAL_ROOT } from './portal-routes';

/** One registry for implemented destinations and primary navigation. */
export const platformRoutes = {
  overview: '/',
  monitoring: '/normal-operations/risk-warning',
  regionalMonitoring: '/normal-operations/risk-warning?mode=monitor&view=monitoring',
  scenario: '/demo/scenario-center',
  workspace: '/mission-workspace',
  equipment: '/demo/capability-equipment',
  provider: PROVIDER_PORTAL_ROOT,
  governance: GOVERNANCE_PORTAL_ROOT,
  queries: '/development/queries',
  /**
   * The P2-BE-SB02 durable 06/08 chain, driven over real HTTP against the Boot host.
   *
   * WHY IT IS ITS OWN DESTINATION AND NOT A TAB INSIDE A PORTAL. The two portals are interaction
   * prototypes over in-memory demo data — deliberately, and they stay that way. This page is the
   * opposite: every value on it came from a server response and it holds no product, decision or
   * publication of its own. Putting it inside a portal would invite a reader to believe the
   * prototype data beside it is equally real.
   *
   * It is NOT in `platformNavigation`: it is a development destination, and a synthetic management
   * write surface has no business appearing in the platform's main navigation.
   */
  durableReview: '/development/product-review',
} as const;

export const platformNavigation = [
  { label: '综合态势', icon: 'home', href: platformRoutes.overview },
  { label: '风险与预警', icon: 'siren', href: platformRoutes.monitoring },
  { label: '场景中心', icon: 'settings', href: platformRoutes.scenario },
  { label: '救援任务工作台', icon: 'clipboard', href: platformRoutes.workspace },
  { label: '能力与装备中心', icon: 'building', href: platformRoutes.equipment },
  { label: '技术 / 解决方案生态', icon: 'network', href: null },
  { label: '知识 / 演练 / 复盘', icon: 'book', href: null },
] as const;

/** Feature-owned destinations. Never rendered as a global SYN menu. */
export const syntheticBusinessRoutes = {
  equipment: `${platformRoutes.equipment}?synLive=1`,
  productManagement: `${PROVIDER_PORTAL_ROOT}/products?synLive=1`,
  reviewCenter: `${GOVERNANCE_PORTAL_ROOT}/queue?synLive=1`,
} as const;

export function isOverviewPath(path: string): boolean {
  return path === platformRoutes.overview || path.replace(/\/$/, '') === '/demo/page-01';
}
